import config from '@bingads-webui-component-legacy/config/index';
import AdExtensionEditor from '@bingads-webui-campaign-legacy/adextension-shared/view/extension-editor';
import subtitleTemplate from '@bingads-webui-campaign-legacy/adextension-app/template/subtitle.pug';
import warningTemplate from '@bingads-webui-campaign-legacy/adextension-app/template/warning.pug';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/adextensions');
const schema = window.globalLegacySchema.get('AppAdExtension');

function getiOSAppStoreId(appStoreId, platform) {
  // If the app platform is iOS and app id start with 'id', we only take the remaining string
  if (platform === 'iOS' && appStoreId.toUpperCase().indexOf('ID') === 0) {
    return appStoreId.substring(2);
  }

  return appStoreId;
}

function getAppStoreIdLabel(AppPlatform) {
  return AppPlatform === 'Android' ?
    i18n.get('AdExtensions_App_Dialog_Field_Package_Name') :
    i18n.get('AdExtensions_App_Dialog_Field_AppStoreId');
}

export default class AppAdExtensionEditor extends AdExtensionEditor {
  initialize({
    extension,
    data,
    instrumentation,
    instrumentationSettings,
  }) {
    const permissions = config.get('Permissions') || {};

    this.appInstallTrackingSupported = permissions.IsAppExtensionInstallTrackingSupported;

    if (extension) {
      extension.AppStoreId = getiOSAppStoreId(extension.AppStoreId, extension.AppPlatform);
    }

    const fields = this.appInstallTrackingSupported ? [{
      property: 'AppPlatform',
      label: i18n.get('AdExtensions_App_Dialog_Field_Mobile_OS'),
    }, {
      property: 'AppStoreId',
      placeholder: {
        depends: ['AppPlatform'],
        computedBy(AppPlatform) {
          if (AppPlatform === 'Android') {
            return i18n.get('AdExtensions_App_Editor_Sample_Package_Name_Android');
          } else if (AppPlatform === 'iOS') {
            return i18n.get('AdExtensions_App_Editor_Sample_Package_Name_iOS');
          }
          return i18n.get('AdExtensions_App_Editor_Sample_Package_Name_Windows');
        },
      },
      label: {
        depends: ['AppPlatform'],
        computedBy(AppPlatform) {
          return getAppStoreIdLabel(AppPlatform);
        },
      },
      helpId: 'pop_BA_CampaignCreate_Ads_AppExtensionPackageName',
    }, {
      property: 'DisplayText',
      showHint: true,
      placeholder: i18n.get('AdExtensions_App_Editor_Link_Placeholder_Text'),
      helpId: 'pop_BA_CampaignCreate_Ads_AppExtensionLinkText',
    }, {
      property: 'DevicePreference',
      values: ['Mobile', 'All'],
      control: 'checkbox',
    }, {
      property: 'DestinationUrl',
      showHint: true,
      placeholder: i18n.get('AdExtensions_App_Editor_URL_Placeholder_Text'),
      label: i18n.get('AdExtensions_App_Dialog_Field_App_Measurement_URL'),
    }] : [{
      property: 'AppPlatform',
      label: i18n.get('AdExtensions_App_Dialog_Field_AppPlatform'),
    }, {
      property: 'AppStoreId',
      placeholder: i18n.get('AdExtensions_App_Dialog_AppStoreIdPlaceholder'),
      label: i18n.get('AdExtensions_App_Dialog_Field_AppStoreId'),
    }, {
      property: 'DisplayText',
      showHint: true,
    }, {
      property: 'DestinationUrl',
      showHint: true,
    }];

    super.initialize({
      extension,
      data,
      schema,
      fields,
      instrumentation,
      instrumentationSettings,
    });
  }

  render() {
    super.render();

    this.$('.form-group[data-property="$overall"]').append(subtitleTemplate({
      i18n,
      appInstallTrackingSupported: this.appInstallTrackingSupported,
    }));

    if (this.appInstallTrackingSupported) {
      this.$('.alert .alert-spacing').replaceWith(warningTemplate({ i18n }));
    }

    return this;
  }

  currentModel() {
    const model = super.currentModel();

    if (!this.appInstallTrackingSupported) {
      model.DevicePreference = null;
    }

    delete model.$alert;

    return model;
  }
}
